<div class="modal-dialog modal-confirm">
  <div class="modal-content">
    <div class="modal-header flex-column">
      <div class="icon-box">
        <i class="material-icons">&#xE5CD;</i>
      </div>
      <h4 class="modal-title w-100">Prix de vente invalide</h4>
    </div>

    <div class="modal-body plain-message">
      <p class="warning-title text-center">
        ⚠️ Les produits suivants ont un prix de vente inférieur au prix d'achat :
      </p>
      <ul class="product-list">
        <li *ngFor="let name of data.invalidProducts">{{ name }}</li>
      </ul>
    </div>

    <div class="modal-footer justify-content-center no-margin-footer">
      <button type="button" class="btn btn-danger btn-lg" (click)="onClose()">OK</button>
    </div>
  </div>
</div>
